var fromLabelStyle = {
    container: {
        default: {
            position: 'relative'
        },
        accessibleOnly: {
            position: 'absolute',
            left: '-100000px',
            top: 'auto',
            width: '1px',
            height: '1px',
            overflow: 'hidden'
        }
    },
    label: {
        default: {
            fontFamily: "'Rubik', 'Helvetica', 'Arial'",
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: 'normal',
            lineHeight: '1.25',
            textIndent: 0,
            textShadow: 'none',
            textTransform: 'none',
            color: 'rgb(105,113,122)',
            display: 'block',
            fontSize: '0.8125rem',
            margin: '0 0 0.25rem',
            padding: 0,
            verticalAlign: 'top'
        },
        textDirection: {
            rtl: {
                textAlign: 'right'
            },
            ltr: {
                textAlign: 'left'
            }
        }
    },
    requiredIndicatorContainer: {
        default: {
            fontFamily: "'Rubik', 'Helvetica', 'Arial'",
            fontStyle: 'normal',
            fontWeight: 300,
            letterSpacing: 'normal',
            lineHeight: '1.25',
            textIndent: 0,
            textShadow: 'none',
            textTransform: 'none',
            position: 'absolute',
            color: 'rgb(219,44,0)',
            fontSize: '1.25rem'
        },
        textDirection: {
            rtl: {
                right: '-11px',
                textAlign: 'right'
            },
            ltr: {
                left: '-11px',
                textAlign: 'left'
            }
        }
    }
};
export default fromLabelStyle;
